import {SaludiaDrawerOrigin} from 'presentation/pages/private/store/useSaludiaDrawerStore/types';

export const SALUDIA_URLS: Record<SaludiaDrawerOrigin, string> = {
	'network-provider':
		'https://notredame.saludia.com.br/notredame?utm_source=notredame&utm_medium=app&utm_campaign=20250130_link_app_convenio_1',
	services:
		'https://notredame.saludia.com.br/notredame?utm_source=notredame&utm_medium=app&utm_campaign=20250130_link_app_convenio_2',
};
